'use client';
var defaultPropObject = Object();
var isDomAvailable = function() {
    return typeof window === "object";
};
var isMatchMediaAvailable = function() {
    return isDomAvailable() && "matchMedia" in window;
};

export { defaultPropObject, isDomAvailable, isMatchMediaAvailable };
